import { ViralShortsForm } from '@/features/factory/subfactories/ViralShortsForm'

/** Sub-route /factory/viral-shorts — wraps the form component. */
export function ViralShortsPage() {
  return <ViralShortsForm />
}
